<template>
	<div class="c-parking-calculator__wrapper">
		<div class="c-parking-calculator__park-and-ride">
			<div class="tr">
				<div class="th">Time</div>
				<div class="th">Cost</div>
			</div>
			<div class="tr">
				<div class="td">Up to 4 hours</div>
				<div class="td">${{rateUpTo4Hours}}</div>
			</div>
			<div class="tr">
				<div class="td">Up to 12 hours</div>
				<div class="td">${{rateUpTo12Hours}}</div>
			</div>
			<div class="tr">
				<div class="td">Up to 24 hours</div>
				<div class="td">${{rateUpTo24Hours}}</div>
			</div>
			<div class="tr">
				<div class="td">Each additional day (or part thereof)</div>
				<div class="td">${{rateAdditionalDay}}</div>
			</div>
		</div>
		<div class="c-parking-calculator__calculator-card">
			<div class="c-parking-calculator__calculator-card-header">
				Park &amp; Ride Price Calculator
			</div>
			<div class="c-parking-calculator__calculator-card-body">
				<div class="text-intructions-calculator">
					Type the number of days or drag slider
				</div>
				<div class="text-days-calc text-blue">
					<label for="days" class="text-blue">Number of Days:</label>
					<input type="number" id="days" v-model="inputValue" min="1" max="30">
				</div>
				<div class="range-slider">
					<input type="range" id="slider" v-model="inputValue" min="1" max="30" value="1">
				</div>
			</div>
			<div class="c-parking-calculator__calculator-card-results">
				<div class="price" id="price">
					<span>Total Price: </span>
					${{price}}
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { ref, } from 'vue';
	export default {
		name: 'parkingcalculator',
		data() {
			return {
				inputValue: 1,
				price: 20,
				initialDays: 1,
				rateUpTo4Hours: 4,
				rateUpTo12Hours: 8,
				rateUpTo24Hours: 20,
				rateAdditionalDay: 10
			}
		},
		mounted() {
			this.getElementData();
		},
		watch: {
			inputValue(newVal, oldVal) {
				this.calculatePrice();
			}
		},
		computed: {

		},
		methods: {

			getElementData() {

				const ParkingCalculator = document.getElementById('ParkingCalculator');
				let data = null;

				if (ParkingCalculator) {
					data = ParkingCalculator.dataset.parking;
				}

				if (data) {
					const parsedData = JSON.parse(data);

					// Update properties if they exist in the parsed data
					this.initialDays = parsedData.initialNumberOfDays || this.initialDays;
					this.rateUpTo4Hours = parsedData.rateUpTo4Hours || this.rateUpTo4Hours;
					this.rateUpTo12Hours = parsedData.rateUpTo12Hours || this.rateUpTo12Hours;
					this.rateUpTo24Hours = parsedData.rateUpTo24Hours || this.rateUpTo24Hours;
					this.rateAdditionalDay = parsedData.rateEachAdditionalDay || this.rateAdditionalDay;

					// Set initial values
					this.inputValue = this.initialDays;
					this.calculatePrice();
				}
			},

			calculatePrice() {
				var days = this.inputValue;
				var price = this.rateUpTo24Hours + (days - 1) * 10;

				this.price = price;
			}
		}
	};
</script>